import { InfiniteData } from '@tanstack/react-query';
import { isSameDay, parseISO } from 'date-fns';
import { IGatheringChatItem } from '../types';

export const pushMessage = (
  data: InfiniteData<IGatheringChatItem[]>,
  comment: IGatheringChatItem,
): InfiniteData<IGatheringChatItem[]> => {
  if (!data) return data;
  const currPage = data?.pages?.length - 1;
  data.pages[currPage] = [comment, ...data?.pages[currPage]];
  return data;
};

export const editMessage = (
  data: InfiniteData<IGatheringChatItem[]>,
  comment: IGatheringChatItem,
): InfiniteData<IGatheringChatItem[]> => {
  if (!data) return data;
  for (let i = data.pages.length - 1; i >= 0; i -= 1) {
    const currentPage = data?.pages[i];
    for (let j = currentPage.length - 1; j >= 0; j -= 1) {
      if (currentPage[j]._id === comment._id) {
        currentPage[j] = comment;
      }
    }
  }
  return data;
};

export const removeMessage = (
  data: InfiniteData<IGatheringChatItem[]>,
  comment: IGatheringChatItem,
): InfiniteData<IGatheringChatItem[]> => {
  if (!data) return data;
  for (let i = data.pages.length - 1; i >= 0; i -= 1) {
    const currentPage = data?.pages[i];
    for (let j = currentPage.length - 1; j >= 0; j -= 1) {
      if (currentPage[j]._id === comment._id) {
        currentPage.splice(j, 1);
      }
    }
  }
  return data;
};

export const getSameDateAndAuthor = (
  message: IGatheringChatItem,
  previousMessage: IGatheringChatItem,
) => {
  const createdAt = parseISO(message.createdAt);
  const isSameDayAsPreviousMessage =
    previousMessage &&
    isSameDay(parseISO(previousMessage?.createdAt), createdAt);

  const isSameAuthorAsPreviousMessage =
    isSameDayAsPreviousMessage && previousMessage?.author === message.author;

  return {
    ...message,
    isSameDayAsPreviousMessage,
    isSameAuthorAsPreviousMessage,
  };
};
